module.exports = __webpack_public_path__ + "img/mengHu6.9f4653c3.png";